import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phone', pure: true })
export class PhonePipe implements PipeTransform {
  transform(
    rawValue?: unknown,
    format: string = '(000) 000-0000'
  ): string | undefined {
    if (typeof rawValue !== 'string' && typeof rawValue !== 'number') {
      return undefined;
    }

    const value: string = rawValue.toString();
    
    // Extract phone number from HTML if present
    const extractedValue: string = this.extractPhoneFromHtml(value);
    let cleanedValue: string = extractedValue.replace(/\D/g, '');
    
    if (!cleanedValue) {
      return undefined;
    }
    
    // Strip leading US country code (1) if number has 11+ digits and starts with 1
    // This handles cases like +19733521511 -> 9733521511
    // and +1 (123) 456-7890 ext. 123 -> 1234567890
    if (cleanedValue.length >= 11 && cleanedValue.startsWith('1')) {
      cleanedValue = cleanedValue.substring(1);
    }
    
    let formattedValue: string = '';
    let formatIndex: number = 0;

    for (
      let i: number = 0;
      i < cleanedValue.length && formatIndex < format.length;
      i++
    ) {
      if (format[formatIndex] === '0') {
        formattedValue += cleanedValue[i];
        formatIndex++;
      } else {
        formattedValue += format[formatIndex];
        i--;
        formatIndex++;
      }
    }

    return formattedValue;
  }

  private extractPhoneFromHtml(value: string): string {
    // Check if the value contains HTML tags
    if (!value.includes('<') || !value.includes('>')) {
      return value;
    }

    // Try to extract from href attribute (tel:xxx or tel:+xxx)
    // Handles both single and double quotes, with or without + sign
    const hrefMatch = value.match(/href\s*=\s*["']tel:([^"']+)["']/i);
    if (hrefMatch && hrefMatch[1]) {
      return hrefMatch[1];
    }

    // Try to extract from text content between tags
    const textMatch = value.match(/>([^<]+)</);
    if (textMatch && textMatch[1]) {
      return textMatch[1].trim();
    }

    // Fallback to the original value
    return value;
  }
}
